export const MODAL = {
  MAX_IMAGES: {
    BODY: 'Solo se permite cargar una (1) foto de este documento.',
    TITLE: 'Excedió la cantidad de fotos',
    BUTTON_LABEL: 'Entendido',
  },
}
